import { Reducer } from 'redux';
import { ReportsState, ReportsActionTypes } from '../types';

export const DeviceDetailsDefaultState: ReportsState = {
    deviceDetails: {
        deviceDetailsStats: [],
        loading: false,
    },
};

const reducer: Reducer<ReportsState> = (state: ReportsState = DeviceDetailsDefaultState, action): ReportsState => {
    switch (action.type) {
        case ReportsActionTypes.GET_DEVICE_DETAILS:
        case ReportsActionTypes.GET_DEVICE_DETAILS_CAMPAIGNS:
            return { ...state, deviceDetails: { ...state.deviceDetails, loading: true } };
        case ReportsActionTypes.GET_DEVICE_DETAILS_SUCCESS:
        case ReportsActionTypes.GET_DEVICE_DETAILS_CAMPAIGNS_SUCCESS:
            return {
                ...state,
                deviceDetails: {
                    ...state.deviceDetails,
                    deviceDetailsStats: action.payload.deviceDetailsStats,
                    loading: false,
                },
            };
        case ReportsActionTypes.GET_DEVICE_DETAILS_ERROR:
        case ReportsActionTypes.GET_DEVICE_DETAILS_CAMPAIGNS_ERROR:
            return { ...state, deviceDetails: { ...state.deviceDetails, loading: false } };
        default:
            return state;
    }
};

export { reducer as deviceDetails };

export default reducer;
